<template>
  <router-view></router-view>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'app',
  methods: {
    ...mapActions({ fetchProgress: 'progress/fetch' }),
    ...mapActions({ loadUser: 'user/load' })
  },
  mounted() {
    // set initial state
    this.loadUser();
    this.fetchProgress();
  }
};
</script>

<style lang="scss">
// CoreUI Icons Set
@import '~@coreui/icons/css/coreui-icons.min.css';
// Import Font Awesome icons set
$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/css/font-awesome.min.css';
// Import Simple Line icons set
$simple-line-font-path: '~simple-line-icons/fonts/';
@import '~simple-line-icons/scss/simple-line-icons.scss';
// Import Bootstrap Vue styles
@import '~bootstrap-vue/dist/bootstrap-vue.css';
// Import main styles for this application
@import 'assets/scss/style';

// View background colors
.list-view {
  background-color: #fff;
}
.print-view {
  background-color: #fff;
}
.setup-view {
  background-color: #fff;
}
@media (max-width: 991px) {
  .main .container-fluid {
    padding: 0 15px;
  }
}

// Table headers
.b-table.table > thead > tr > th[aria-sort],
.b-table.table > tfoot > tr > th[aria-sort] {
  position: relative;
  padding-right: 1.125em;
  cursor: pointer;
  background-image: none;
}
.b-table.table > thead > tr > th[aria-sort]::after,
.b-table.table > tfoot > tr > th[aria-sort]::after {
  position: absolute;
  display: block;
  bottom: 0;
  right: 0.35em;
  padding-bottom: inherit;
  font-family: FontAwesome !important;
  font-size: inherit;
  line-height: inherit;
  opacity: 0.4;
  content: '\f0dc';
  background-image: none;
}
.b-table.table > thead > tr > th[aria-sort][aria-sort='ascending']::after,
.b-table.table > tfoot > tr > th[aria-sort][aria-sort='ascending']::after {
  opacity: 1;
  content: '\f160';
}
.b-table.table > thead > tr > th[aria-sort][aria-sort='descending']::after,
.b-table.table > tfoot > tr > th[aria-sort][aria-sort='descending']::after {
  opacity: 1;
  content: '\f161';
}
</style>
